<template>
  <div class="exam-layout">
    <slot/>
  </div>
</template>

<script>
export default {
  name: 'ExamLayout'
}
</script>

<style scoped>
.exam-layout {
    background-color: #f3f2f9;
    padding-top:0;
}

</style>
